/* Warenkorb-Schublade (AJAX).
   Aus dem Inline-<script> von snippets/cart-drawer.liquid ausgelagert (2026-07-31).
   Grund: das Snippet rendert einmal im Layout, das Skript stand damit als 17.5 KiB
   im Dokument JEDER Seite — unkomprimiert im render-blockierenden Pfad und bei
   jedem Seitenaufruf erneut. Als Asset wird es von Shopify minifiziert, ist
   zwischenspeicherbar und faellt aus dem Dokument heraus.

   `defer` ist unbedenklich: das Skript fragt sein Wurzelelement mit
   document.getElementById ab und steigt aus, wenn es fehlt. Als Inline-Skript lief es
   waehrend des Parsens (das Markup steht darueber), mit `defer` nach dem Parsen —
   also mit MEHR Dokument, nicht weniger. Gleiche Begruendung wie beim Menue-Umzug
   am 30.07. (blocks/menu.liquid).
*/
/**
 * Hyprism Cart Drawer - AJAX Cart System
 * Intercepts add-to-cart forms, manages cart state via AJAX
 */
(function() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  const openOnAdd = drawer.dataset.openOnAdd !== '0';

  const body = drawer.querySelector('[data-cart-drawer-body]');
  const itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  const emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
  const footerEl = drawer.querySelector('[data-cart-drawer-footer]');
  const countEl = drawer.querySelector('[data-cart-drawer-count]');
  const subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');

  /* ========== Open / Close ========== */
  const panel = drawer.querySelector('[role="dialog"]');
  let lastFocused = null;

  /* Visible, focusable elements inside the dialog panel (for focus-in + trap). */
  function focusable() {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(el => el.offsetWidth > 0 || el.offsetHeight > 0);
  }

  /* ---- Frame weld (opt-in, cart_drawer_connect_frame) ---------------------
     Mirrors the burger drawer weld JS in header.liquid. The cart drawer always
     comes from the RIGHT, so it tags the body with ne-drawer-open--right and
     drives the SHARED --ne-drawer-edge (@property registered in header-styles-2)
     so the drawer slide and the frame's right-edge retreat move in lockstep. */
  const isWeld = drawer.classList.contains('ne-cart-drawer--weld');
  const root = document.documentElement;

  /* Slide duration — drawer_slide_speed (--ne-drawer-speed), with the nav dropdown
     speed as legacy fallback. Must match the :root --ne-drawer-edge transition. */
  function drawerSpeed() {
    const cs = getComputedStyle(root);
    return parseFloat(cs.getPropertyValue('--ne-drawer-speed')) ||
           parseFloat(cs.getPropertyValue('--ne-dropdown-speed')) || 280;
  }

  function applyCartWeld() {
    if (!isWeld) return;
    /* offsetWidth is transform-independent → the resting width even while the
       panel is translated off-screen. */
    /* ⚠️ Rule 487: offsetWidth kann direkt nach showModal() 0 liefern. Die Breite
       steht als --ne-drawer-width inline am Panel — als Rueckfall auslesen, sonst
       parkt der Drawer bei 0 und erscheint ohne Slide. */
    let w = Math.max(0, Math.round(panel.offsetWidth));
    if (!w) w = Math.max(0, Math.round(parseFloat(getComputedStyle(panel).getPropertyValue('--ne-drawer-width')) || 0));
    root.style.setProperty('--ne-drawer-w', w + 'px');
    root.style.setProperty('--ne-drawer-edge', '0px'); // start off-screen (no jump)
    const vw = window.innerWidth, vh = window.innerHeight;
    const frameEl = document.querySelector('.ne-layer-frame');
    let frameTop = 0, frameInset = 8;
    if (frameEl) {
      const fr = frameEl.getBoundingClientRect();
      frameTop = Math.max(0, Math.round(fr.top));
      frameInset = Math.max(0, Math.round(vh - fr.bottom)); // uniform side/bottom gap
      root.style.setProperty('--ne-drawer-frame-inset', frameInset + 'px');
      root.style.setProperty('--ne-drawer-frame-radius', getComputedStyle(frameEl).borderTopLeftRadius);
    }
    // Classify the header so we (a) don't collapse the drawer under a full-height
    // SIDE header (desktop) — only a real horizontal TOP-BAR is subtracted from the
    // drawer top — and (b) don't let the dim/blur overlay run OVER the header:
    // the overlay is inset past the header strip on whichever edge it occupies.
    let drawerTop = frameTop;
    let ovTop = frameTop, ovLeft = frameInset, ovRight = frameInset, ovBottom = frameInset;
    const hdr = document.querySelector('.ne-header');
    if (hdr) {
      const hb = hdr.getBoundingClientRect();
      const topBar = hb.width >= vw * 0.6 && hb.bottom <= vh * 0.5;
      const leftBar = hb.height >= vh * 0.6 && hb.right <= vw * 0.5;
      const rightBar = hb.height >= vh * 0.6 && hb.left >= vw * 0.5;
      if (topBar) { drawerTop = Math.max(drawerTop, Math.round(hb.bottom)); ovTop = drawerTop; }
      if (leftBar) ovLeft = Math.max(ovLeft, Math.round(hb.right));
      if (rightBar) ovRight = Math.max(ovRight, Math.round(vw - hb.left));
    }
    root.style.setProperty('--ne-drawer-top', drawerTop + 'px');
    root.style.setProperty('--ne-cart-ov-top', ovTop + 'px');
    root.style.setProperty('--ne-cart-ov-left', ovLeft + 'px');
    root.style.setProperty('--ne-cart-ov-right', ovRight + 'px');
    root.style.setProperty('--ne-cart-ov-bottom', ovBottom + 'px');
    document.body.classList.add('ne-drawer-open', 'ne-drawer-open--right');
    /* One frame later (so edge:0 commits first), animate edge → width: the drawer
       slides in AND the frame edge tracks it in perfect lockstep. */
    requestAnimationFrame(() => {
      root.style.setProperty('--ne-drawer-edge', w + 'px');
    });
  }

  function finalizeCartWeld() {
    if (!isWeld) return;
    document.body.classList.remove('ne-drawer-open', 'ne-drawer-open--right');
    ['--ne-drawer-edge', '--ne-drawer-w', '--ne-drawer-top', '--ne-drawer-frame-inset', '--ne-drawer-frame-radius',
     '--ne-cart-ov-top', '--ne-cart-ov-left', '--ne-cart-ov-right', '--ne-cart-ov-bottom']
      .forEach((p) => root.style.removeProperty(p));
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    /* showModal() → top layer: der Drawer liegt damit ueber jedem z-index, auch
       ueber App-Knoepfen. Fallback fuer UAs ohne <dialog>: das open-Attribut. */
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', '');
    applyCartWeld(); // measures the (now-laid-out) panel + sets frame vars/classes
    requestAnimationFrame(() => {
      drawer.classList.add('ne-cart-drawer--open');
      /* Move keyboard focus into the dialog (first focusable = close button). */
      const f = focusable();
      if (f[0]) f[0].focus();
    });
    /* Scroll-Sperre kommt jetzt ueber das scroll-lock-Attribut (critical.css:56),
       wie beim Burger-Drawer — kein manuelles body.style.overflow mehr. */
  }

  /* Erst schliessen, wenn die Slide-Animation durch ist — sonst verschwindet der
     Drawer schlagartig (display:none), statt hinauszufahren. */
  function closeDialog() {
    if (typeof drawer.close === 'function' && drawer.open) drawer.close();
    else drawer.removeAttribute('open');
  }

  function closeDrawer() {
    drawer.classList.remove('ne-cart-drawer--open');
    if (isWeld) {
      /* Retreat the edge → the drawer slides out and the frame returns in lockstep.
         KEEP the body classes live until the slide finishes (they gate the frame
         `right: max(.., edge)` rule — dropping them early would snap the frame back
         and expose the fill as a panel). Cleared + hidden after the animation. */
      root.style.setProperty('--ne-drawer-edge', '0px');
      setTimeout(() => { closeDialog(); finalizeCartWeld(); }, drawerSpeed() + 20);
    } else {
      setTimeout(() => {
        closeDialog();
      }, 300);
    }
    /* Return focus to the element that opened the drawer (e.g. the cart icon). */
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  /* Focus trap — keep Tab/Shift+Tab inside the dialog while it is open. */
  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !drawer.open) return;
    const f = focusable();
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* Close buttons */
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  });

  /* Click on the bare root (outside the panel) closes too. In weld mode the
     overlay is inset to the frame's inner rect, so the header-row strip above it
     is bare root, not overlay — without this, clicking there wouldn't dismiss
     (the root still covers the viewport at z-modal). Mirrors the burger weld's
     header catcher. Clicks on the panel/overlay are handled by their own paths. */
  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) closeDrawer();
  });

  /* ESC loest am <dialog> `cancel` aus und wuerde nativ SOFORT schliessen — das
     ueberspringt die Slide-Animation und laesst beim Weld die Frame-Kante stehen.
     Abfangen und ueber closeDrawer() gehen, wie im Burger-Drawer. */
  drawer.addEventListener('cancel', (e) => { e.preventDefault(); closeDrawer(); });

  /* Escape key */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.open) closeDrawer();
  });

  /* Expose globally */
  window.NECart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart
  };

  /* ========== AJAX Cart Operations ========== */

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateDrawerUI(cart);
        updateHeaderCount(cart.item_count);
        return cart;
      });
  }

  /* ⚠️ HIER STAND EIN NACHLADEN DER EXPRESS-KNOEPFE — es ist am 2026-07-30 wieder
     ausgebaut worden, weil es nachweislich NICHT geht, und das Scheitern teuer ist.
     Idee war: legt der erste Artikel im Korb, das Wallet-Markup von der
     Warenkorb-Seite holen und in den Fuss einsetzen, damit die Knoepfe ohne
     Seitenwechsel erscheinen. Gemessen an 21rebel, Schublade offen:
       · `/cart?section_id=main` → **404**, `?sections=main` → 200 mit **13 Bytes**
         (leerer Abschnitt). Brauchbar ist nur die volle `/cart`-Seite.
       · Aus deren `.ne-cart-summary__dynamic-checkout` eingesetzt, wird
         `shopify-accelerated-checkout-cart` zwar DEFINIERT (Shopify laedt sein
         Bundle daraufhin nach) und feuert **9 PayPal-Anfragen** — das Element
         bleibt aber ueber **15 Sekunden** bei **Hoehe 0**. Es rendert nie.
     Shopify richtet seine Wallet-Komponenten offenbar beim Seitenaufbau ein;
     spaeter eingefuegte Elemente werden nicht mehr initialisiert. Ergebnis waere
     also: die vollen Kosten, kein Knopf. Deshalb bleibt es dabei, dass die
     Express-Knoepfe ab dem NAECHSTEN Seitenaufruf erscheinen. */

  function updateDrawerUI(cart) {
    /* Count */
    if (countEl) countEl.textContent = cart.item_count;

    /* Subtotal */
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    /* Show/hide empty state */
    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = '';
      if (footerEl) footerEl.style.display = 'none';
      if (itemsContainer) itemsContainer.innerHTML = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = '';

    /* Render items */
    if (itemsContainer) {
      itemsContainer.innerHTML = cart.items.map((item, index) => {
        const img = item.image ? `<a href="${item.url}"><img src="${item.image.replace(/(\.[^.]+)$/, '_120x$1')}" alt="" class="ne-cart-drawer__item-img" loading="eager" fetchpriority="high" decoding="async"></a>` : '';
        const variant = item.variant_title ? `<p class="ne-text-muted ne-text-xs">${item.variant_title}</p>` : '';
        const priceHtml = item.original_price !== item.final_price
          ? `<span style="color:var(--ne-scheme-accent);">${formatMoney(item.final_price)}</span> <s class="ne-text-muted">${formatMoney(item.original_price)}</s>`
          : `<span>${formatMoney(item.original_price)}</span>`;

        return `
          <div class="ne-cart-drawer__item" data-cart-drawer-item data-line="${index + 1}" data-key="${item.key}">
            <div class="ne-cart-drawer__item-media">${img}</div>
            <div class="ne-cart-drawer__item-details">
              <a href="${item.url}" class="ne-cart-drawer__item-title">${item.product_title}</a>
              ${variant}
              <div class="ne-cart-drawer__item-price ne-text-sm">${priceHtml}</div>
              <div class="ne-cart-drawer__item-qty">
                <button type="button" class="ne-cart-drawer__qty-btn" data-drawer-qty-change="-1" aria-label="Decrease">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </button>
                <span class="ne-cart-drawer__qty-val" data-drawer-qty-val>${item.quantity}</span>
                <button type="button" class="ne-cart-drawer__qty-btn" data-drawer-qty-change="1" aria-label="Increase">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </button>
                <button type="button" class="ne-cart-drawer__remove" data-drawer-remove aria-label="Remove">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                </button>
              </div>
            </div>
            <div class="ne-cart-drawer__item-line-price ne-text-sm" style="font-weight: 600;" data-drawer-line-price>
              ${formatMoney(item.final_line_price)}
            </div>
          </div>
        `;
      }).join('');
    }
  }

  function updateHeaderCount(count) {
    /* Update all cart count indicators in header. Toggle the --hidden CLASS
       (not just inline display) — the badge starts with .ne-header__cart-count
       --hidden when the cart is empty, and that class's `display:none` wins
       over an empty inline display, so the badge stayed hidden after the
       first add (user 2026-05-24). */
    document.querySelectorAll('.ne-header__cart-count, [data-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('ne-header__cart-count--hidden', count === 0);
      el.style.display = '';
    });
  }

  function changeQuantity(line, quantity) {
    const item = itemsContainer.querySelector(`[data-line="${line}"]`);
    if (item) item.classList.add('ne-cart-drawer__item--loading');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(r => r.json())
    .then(cart => {
      updateDrawerUI(cart);
      updateHeaderCount(cart.item_count);
      return cart;
    });
  }

  /* ========== Event Delegation ========== */

  /* Quantity change in drawer */
  drawer.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-drawer-qty-change]');
    if (qtyBtn) {
      const item = qtyBtn.closest('[data-cart-drawer-item]');
      const line = parseInt(item.dataset.line);
      const valEl = item.querySelector('[data-drawer-qty-val]');
      const currentQty = parseInt(valEl.textContent);
      const change = parseInt(qtyBtn.dataset.drawerQtyChange);
      const newQty = Math.max(0, currentQty + change);
      changeQuantity(line, newQty);
      return;
    }

    const removeBtn = e.target.closest('[data-drawer-remove]');
    if (removeBtn) {
      const item = removeBtn.closest('[data-cart-drawer-item]');
      const line = parseInt(item.dataset.line);
      changeQuantity(line, 0);
      return;
    }
  });

  /* ========== Intercept Add-to-Cart Forms ========== */

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      e.preventDefault();

      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
      const originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        return refreshCart();
      })
      .then(() => {
        if (openOnAdd) openDrawer();
        if (submitBtn) {
          submitBtn.textContent = 'Added!';
          setTimeout(() => {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 1500);
        }
      })
      .catch(err => {
        console.error('Cart error:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
    }
  });

  /* ========== Header Cart Icon -> Open Drawer ========== */

  document.querySelectorAll('.ne-header__cart, [data-cart-trigger]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

  /* ========== External cart-add events ========== */
  /* Schnellkauf aus JS-Rastern und aus der Produktkarte POSTen beide auf
     /cart/add.js directly (no form submit) and then dispatch
     ne:cart-updated on `document`. Refresh the drawer and pop it open. */
  document.addEventListener('ne:cart-updated', () => {
    refreshCart().then(() => { if (openOnAdd) openDrawer(); });
  });

})();
